var _excluded = ["scaffoldBlockPxWidth", "toggleChildrenVisibility", "connectDragPreview", "connectDragSource", "isDragging", "canDrop", "canDrag", "node", "title", "subtitle", "draggedNode", "path", "treeIndex", "isSearchMatch", "isSearchFocus", "buttons", "className", "style", "didDrop", "treeId", "isOver", "parentNode", "rowDirection"],
    _excluded2 = ["children", "listIndex", "swapFrom", "swapLength", "swapDepth", "scaffoldBlockPxWidth", "lowerSiblingCounts", "connectDropTarget", "isOver", "draggedNode", "canDrop", "treeIndex", "rowHeight", "treeId", "getPrevRow", "node", "path", "rowDirection"],
    _excluded3 = ["children", "connectDropTarget", "treeId", "drop"],
    _excluded4 = ["dragDropManager", "rowHeight"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { jsx, jsxs } from 'react/jsx-runtime';
import React, { Component, Children, cloneElement } from 'react';
import withScrolling, { createScrollingComponent, createVerticalStrength, createHorizontalStrength } from '@nosferatu500/react-dnd-scrollzone';
import isEqual from 'lodash.isequal';
import { DragSource, DropTarget, DndContext, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Virtuoso } from 'react-virtuoso';

var defaultGetNodeKey = function defaultGetNodeKey(_ref) {
  var treeIndex = _ref.treeIndex;
  return treeIndex;
};

var getReactElementText = function getReactElementText(parent) {
  if (typeof parent === "string") {
    return parent;
  }

  if (parent === void 0 || _typeof(parent) !== "object" || !parent.props || !parent.props.children || typeof parent.props.children !== "string" && _typeof(parent.props.children) !== "object") {
    return "";
  }

  if (typeof parent.props.children === "string") {
    return parent.props.children;
  }

  return parent.props.children.map(function (child) {
    return getReactElementText(child);
  }).join("");
};

var stringSearch = function stringSearch(key, searchQuery, node, path, treeIndex) {
  if (typeof node[key] === "function") {
    return String(node[key]({
      node: node,
      path: path,
      treeIndex: treeIndex
    })).includes(searchQuery);
  }

  if (_typeof(node[key]) === "object") {
    return getReactElementText(node[key]).includes(searchQuery);
  }

  return node[key] && String(node[key]).includes(searchQuery);
};

var defaultSearchMethod = function defaultSearchMethod(_ref2) {
  var node = _ref2.node,
      path = _ref2.path,
      treeIndex = _ref2.treeIndex,
      searchQuery = _ref2.searchQuery;
  return stringSearch("title", searchQuery, node, path, treeIndex) || stringSearch("subtitle", searchQuery, node, path, treeIndex);
};

var getNodeDataAtTreeIndexOrNextIndex = function getNodeDataAtTreeIndexOrNextIndex(_ref3) {
  var targetIndex = _ref3.targetIndex,
      node = _ref3.node,
      currentIndex = _ref3.currentIndex,
      getNodeKey = _ref3.getNodeKey,
      _ref3$path = _ref3.path,
      path = _ref3$path === void 0 ? [] : _ref3$path,
      _ref3$lowerSiblingCou = _ref3.lowerSiblingCounts,
      lowerSiblingCounts = _ref3$lowerSiblingCou === void 0 ? [] : _ref3$lowerSiblingCou,
      _ref3$ignoreCollapsed = _ref3.ignoreCollapsed,
      ignoreCollapsed = _ref3$ignoreCollapsed === void 0 ? true : _ref3$ignoreCollapsed,
      _ref3$isPseudoRoot = _ref3.isPseudoRoot,
      isPseudoRoot = _ref3$isPseudoRoot === void 0 ? false : _ref3$isPseudoRoot;
  var selfPath = isPseudoRoot ? [] : [].concat(_toConsumableArray(path), [getNodeKey({
    node: node,
    treeIndex: currentIndex
  })]);

  if (currentIndex === targetIndex) {
    return {
      node: node,
      lowerSiblingCounts: lowerSiblingCounts,
      path: selfPath
    };
  }

  if (!(node == null ? void 0 : node.children) || ignoreCollapsed && (node == null ? void 0 : node.expanded) !== true) {
    return {
      nextIndex: currentIndex + 1
    };
  }

  var childIndex = currentIndex + 1;
  var childCount = node.children.length;

  for (var i = 0; i < childCount; i += 1) {
    var result = getNodeDataAtTreeIndexOrNextIndex({
      ignoreCollapsed: ignoreCollapsed,
      getNodeKey: getNodeKey,
      targetIndex: targetIndex,
      node: node.children[i],
      currentIndex: childIndex,
      lowerSiblingCounts: [].concat(_toConsumableArray(lowerSiblingCounts), [childCount - i - 1]),
      path: selfPath
    });

    if (result.node) {
      return result;
    }

    childIndex = result.nextIndex;
  }

  return {
    nextIndex: childIndex
  };
};

var getDescendantCount = function getDescendantCount(_ref4) {
  var node = _ref4.node,
      _ref4$ignoreCollapsed = _ref4.ignoreCollapsed,
      ignoreCollapsed = _ref4$ignoreCollapsed === void 0 ? true : _ref4$ignoreCollapsed;
  return getNodeDataAtTreeIndexOrNextIndex({
    getNodeKey: function getNodeKey() {},
    ignoreCollapsed: ignoreCollapsed,
    node: node,
    currentIndex: 0,
    targetIndex: -1
  }).nextIndex - 1;
};

var walkDescendants = function walkDescendants(_ref5) {
  var callback = _ref5.callback,
      getNodeKey = _ref5.getNodeKey,
      ignoreCollapsed = _ref5.ignoreCollapsed,
      _ref5$isPseudoRoot = _ref5.isPseudoRoot,
      isPseudoRoot = _ref5$isPseudoRoot === void 0 ? false : _ref5$isPseudoRoot,
      node = _ref5.node,
      _ref5$parentNode = _ref5.parentNode,
      parentNode = _ref5$parentNode === void 0 ? void 0 : _ref5$parentNode,
      currentIndex = _ref5.currentIndex,
      _ref5$path = _ref5.path,
      path = _ref5$path === void 0 ? [] : _ref5$path,
      _ref5$lowerSiblingCou = _ref5.lowerSiblingCounts,
      lowerSiblingCounts = _ref5$lowerSiblingCou === void 0 ? [] : _ref5$lowerSiblingCou;
  var selfPath = isPseudoRoot ? [] : [].concat(_toConsumableArray(path), [getNodeKey({
    node: node,
    treeIndex: currentIndex
  })]);
  var selfInfo = isPseudoRoot ? void 0 : {
    node: node,
    parentNode: parentNode,
    path: selfPath,
    lowerSiblingCounts: lowerSiblingCounts,
    treeIndex: currentIndex
  };

  if (!isPseudoRoot) {
    var callbackResult = callback(selfInfo);

    if (callbackResult === false) {
      return false;
    }
  }

  if (!node.children || node.expanded !== true && ignoreCollapsed && !isPseudoRoot) {
    return currentIndex;
  }

  var childIndex = currentIndex;
  var childCount = node.children.length;

  if (typeof node.children !== "function") {
    for (var i = 0; i < childCount; i += 1) {
      childIndex = walkDescendants({
        callback: callback,
        getNodeKey: getNodeKey,
        ignoreCollapsed: ignoreCollapsed,
        node: node.children[i],
        parentNode: isPseudoRoot ? void 0 : node,
        currentIndex: childIndex + 1,
        lowerSiblingCounts: [].concat(_toConsumableArray(lowerSiblingCounts), [childCount - i - 1]),
        path: selfPath
      });

      if (childIndex === false) {
        return false;
      }
    }
  }

  return childIndex;
};

var mapDescendants = function mapDescendants(_ref6) {
  var callback = _ref6.callback,
      getNodeKey = _ref6.getNodeKey,
      ignoreCollapsed = _ref6.ignoreCollapsed,
      _ref6$isPseudoRoot = _ref6.isPseudoRoot,
      isPseudoRoot = _ref6$isPseudoRoot === void 0 ? false : _ref6$isPseudoRoot,
      node = _ref6.node,
      _ref6$parentNode = _ref6.parentNode,
      parentNode = _ref6$parentNode === void 0 ? void 0 : _ref6$parentNode,
      currentIndex = _ref6.currentIndex,
      _ref6$path = _ref6.path,
      path = _ref6$path === void 0 ? [] : _ref6$path,
      _ref6$lowerSiblingCou = _ref6.lowerSiblingCounts,
      lowerSiblingCounts = _ref6$lowerSiblingCou === void 0 ? [] : _ref6$lowerSiblingCou;

  var nextNode = _objectSpread({}, node);

  var selfPath = isPseudoRoot ? [] : [].concat(_toConsumableArray(path), [getNodeKey({
    node: nextNode,
    treeIndex: currentIndex
  })]);
  var selfInfo = {
    node: nextNode,
    parentNode: parentNode,
    path: selfPath,
    lowerSiblingCounts: lowerSiblingCounts,
    treeIndex: currentIndex
  };

  if (!nextNode.children || nextNode.expanded !== true && ignoreCollapsed && !isPseudoRoot) {
    return {
      treeIndex: currentIndex,
      node: callback(selfInfo)
    };
  }

  var childIndex = currentIndex;
  var childCount = nextNode.children.length;

  if (typeof nextNode.children !== "function") {
    nextNode.children = nextNode.children.map(function (child, i) {
      var mapResult = mapDescendants({
        callback: callback,
        getNodeKey: getNodeKey,
        ignoreCollapsed: ignoreCollapsed,
        node: child,
        parentNode: isPseudoRoot ? void 0 : nextNode,
        currentIndex: childIndex + 1,
        lowerSiblingCounts: [].concat(_toConsumableArray(lowerSiblingCounts), [childCount - i - 1]),
        path: selfPath
      });
      childIndex = mapResult.treeIndex;
      return mapResult.node;
    });
  }

  return {
    node: callback(selfInfo),
    treeIndex: childIndex
  };
};

var getVisibleNodeCount = function getVisibleNodeCount(_ref7) {
  var treeData = _ref7.treeData;

  var traverse = function traverse(node) {
    if (!node.children || node.expanded !== true || typeof node.children === "function") {
      return 1;
    }

    return 1 + node.children.reduce(function (total, currentNode) {
      return total + traverse(currentNode);
    }, 0);
  };

  return treeData.reduce(function (total, currentNode) {
    return total + traverse(currentNode);
  }, 0);
};

var getVisibleNodeInfoAtIndex = function getVisibleNodeInfoAtIndex(_ref8) {
  var treeData = _ref8.treeData,
      targetIndex = _ref8.index,
      getNodeKey = _ref8.getNodeKey;

  if (!treeData || treeData.length === 0) {
    return void 0;
  }

  var result = getNodeDataAtTreeIndexOrNextIndex({
    targetIndex: targetIndex,
    getNodeKey: getNodeKey,
    node: {
      children: treeData,
      expanded: true
    },
    currentIndex: -1,
    path: [],
    lowerSiblingCounts: [],
    isPseudoRoot: true
  });

  if (result.node) {
    return result;
  }

  return void 0;
};

var walk = function walk(_ref9) {
  var treeData = _ref9.treeData,
      getNodeKey = _ref9.getNodeKey,
      callback = _ref9.callback,
      _ref9$ignoreCollapsed = _ref9.ignoreCollapsed,
      ignoreCollapsed = _ref9$ignoreCollapsed === void 0 ? true : _ref9$ignoreCollapsed;

  if (!treeData || treeData.length === 0) {
    return;
  }

  walkDescendants({
    callback: callback,
    getNodeKey: getNodeKey,
    ignoreCollapsed: ignoreCollapsed,
    isPseudoRoot: true,
    node: {
      children: treeData
    },
    currentIndex: -1,
    path: [],
    lowerSiblingCounts: []
  });
};

var map = function map(_ref10) {
  var treeData = _ref10.treeData,
      getNodeKey = _ref10.getNodeKey,
      callback = _ref10.callback,
      _ref10$ignoreCollapse = _ref10.ignoreCollapsed,
      ignoreCollapsed = _ref10$ignoreCollapse === void 0 ? true : _ref10$ignoreCollapse;

  if (!treeData || treeData.length === 0) {
    return [];
  }

  return mapDescendants({
    callback: callback,
    getNodeKey: getNodeKey,
    ignoreCollapsed: ignoreCollapsed,
    isPseudoRoot: true,
    node: {
      children: treeData
    },
    currentIndex: -1,
    path: [],
    lowerSiblingCounts: []
  }).node.children;
};

var toggleExpandedForAll = function toggleExpandedForAll(_ref11) {
  var treeData = _ref11.treeData,
      _ref11$expanded = _ref11.expanded,
      expanded = _ref11$expanded === void 0 ? true : _ref11$expanded;
  return map({
    treeData: treeData,
    callback: function callback(_ref12) {
      var node = _ref12.node;
      return _objectSpread(_objectSpread({}, node), {}, {
        expanded: expanded
      });
    },
    getNodeKey: function getNodeKey(_ref13) {
      var treeIndex = _ref13.treeIndex;
      return treeIndex;
    },
    ignoreCollapsed: false
  });
};

var changeNodeAtPath = function changeNodeAtPath(_ref14) {
  var treeData = _ref14.treeData,
      path = _ref14.path,
      newNode = _ref14.newNode,
      getNodeKey = _ref14.getNodeKey,
      _ref14$ignoreCollapse = _ref14.ignoreCollapsed,
      ignoreCollapsed = _ref14$ignoreCollapse === void 0 ? true : _ref14$ignoreCollapse;
  var RESULT_MISS = "RESULT_MISS";

  var traverse = function traverse(_ref15) {
    var _ref15$isPseudoRoot = _ref15.isPseudoRoot,
        isPseudoRoot = _ref15$isPseudoRoot === void 0 ? false : _ref15$isPseudoRoot,
        node = _ref15.node,
        currentTreeIndex = _ref15.currentTreeIndex,
        pathIndex = _ref15.pathIndex;

    if (!isPseudoRoot && getNodeKey({
      node: node,
      treeIndex: currentTreeIndex
    }) !== path[pathIndex]) {
      return RESULT_MISS;
    }

    if (pathIndex >= path.length - 1) {
      return typeof newNode === "function" ? newNode({
        node: node,
        treeIndex: currentTreeIndex
      }) : newNode;
    }

    if (!node.children) {
      throw new Error("Path referenced children of node with no children.");
    }

    var nextTreeIndex = currentTreeIndex + 1;

    for (var i = 0; i < node.children.length; i += 1) {
      var result2 = traverse({
        node: node.children[i],
        currentTreeIndex: nextTreeIndex,
        pathIndex: pathIndex + 1
      });

      if (result2 !== RESULT_MISS) {
        if (result2) {
          return _objectSpread(_objectSpread({}, node), {}, {
            children: [].concat(_toConsumableArray(node.children.slice(0, i)), [result2], _toConsumableArray(node.children.slice(i + 1)))
          });
        }

        return _objectSpread(_objectSpread({}, node), {}, {
          children: [].concat(_toConsumableArray(node.children.slice(0, i)), _toConsumableArray(node.children.slice(i + 1)))
        });
      }

      nextTreeIndex += 1 + getDescendantCount({
        node: node.children[i],
        ignoreCollapsed: ignoreCollapsed
      });
    }

    return RESULT_MISS;
  };

  var result = traverse({
    node: {
      children: treeData
    },
    currentTreeIndex: -1,
    pathIndex: -1,
    isPseudoRoot: true
  });

  if (result === RESULT_MISS) {
    throw new Error("No node found at the given path.");
  }

  return result.children;
};

var removeNodeAtPath = function removeNodeAtPath(_ref16) {
  var treeData = _ref16.treeData,
      path = _ref16.path,
      getNodeKey = _ref16.getNodeKey,
      _ref16$ignoreCollapse = _ref16.ignoreCollapsed,
      ignoreCollapsed = _ref16$ignoreCollapse === void 0 ? true : _ref16$ignoreCollapse;
  return changeNodeAtPath({
    treeData: treeData,
    path: path,
    getNodeKey: getNodeKey,
    ignoreCollapsed: ignoreCollapsed,
    newNode: void 0 // Delete the node

  });
};

var removeNode = function removeNode(_ref17) {
  var treeData = _ref17.treeData,
      path = _ref17.path,
      getNodeKey = _ref17.getNodeKey,
      _ref17$ignoreCollapse = _ref17.ignoreCollapsed,
      ignoreCollapsed = _ref17$ignoreCollapse === void 0 ? true : _ref17$ignoreCollapse;
  var removedNode;
  var removedTreeIndex;
  var nextTreeData = changeNodeAtPath({
    treeData: treeData,
    path: path,
    getNodeKey: getNodeKey,
    ignoreCollapsed: ignoreCollapsed,
    newNode: function newNode(_ref18) {
      var node = _ref18.node,
          treeIndex = _ref18.treeIndex;
      removedNode = node;
      removedTreeIndex = treeIndex;
      return void 0;
    }
  });
  return {
    treeData: nextTreeData,
    node: removedNode,
    treeIndex: removedTreeIndex
  };
};

var getNodeAtPath = function getNodeAtPath(_ref19) {
  var treeData = _ref19.treeData,
      path = _ref19.path,
      getNodeKey = _ref19.getNodeKey,
      _ref19$ignoreCollapse = _ref19.ignoreCollapsed,
      ignoreCollapsed = _ref19$ignoreCollapse === void 0 ? true : _ref19$ignoreCollapse;
  var foundNodeInfo;

  try {
    changeNodeAtPath({
      treeData: treeData,
      path: path,
      getNodeKey: getNodeKey,
      ignoreCollapsed: ignoreCollapsed,
      newNode: function newNode(_ref20) {
        var node = _ref20.node,
            treeIndex = _ref20.treeIndex;
        foundNodeInfo = {
          node: node,
          treeIndex: treeIndex
        };
        return node;
      }
    });
  } catch (_unused) {}

  return foundNodeInfo;
};

var addNodeUnderParent = function addNodeUnderParent(_ref21) {
  var treeData = _ref21.treeData,
      newNode = _ref21.newNode,
      _ref21$parentKey = _ref21.parentKey,
      parentKey = _ref21$parentKey === void 0 ? void 0 : _ref21$parentKey,
      getNodeKey = _ref21.getNodeKey,
      _ref21$ignoreCollapse = _ref21.ignoreCollapsed,
      ignoreCollapsed = _ref21$ignoreCollapse === void 0 ? true : _ref21$ignoreCollapse,
      _ref21$expandParent = _ref21.expandParent,
      expandParent = _ref21$expandParent === void 0 ? false : _ref21$expandParent,
      _ref21$addAsFirstChil = _ref21.addAsFirstChild,
      addAsFirstChild = _ref21$addAsFirstChil === void 0 ? false : _ref21$addAsFirstChil;

  if (parentKey === null || parentKey === void 0) {
    return addAsFirstChild ? {
      treeData: [newNode].concat(_toConsumableArray(treeData || [])),
      treeIndex: 0
    } : {
      treeData: [].concat(_toConsumableArray(treeData || []), [newNode]),
      treeIndex: (treeData || []).length
    };
  }

  var insertedTreeIndex;
  var hasBeenAdded = false;
  var changedTreeData = map({
    treeData: treeData,
    getNodeKey: getNodeKey,
    ignoreCollapsed: ignoreCollapsed,
    callback: function callback(_ref22) {
      var node = _ref22.node,
          treeIndex = _ref22.treeIndex,
          path = _ref22.path;
      var key = path ? path[path.length - 1] : void 0;

      if (hasBeenAdded || key !== parentKey) {
        return node;
      }

      hasBeenAdded = true;

      var parentNode = _objectSpread({}, node);

      if (expandParent) {
        parentNode.expanded = true;
      }

      if (!parentNode.children) {
        insertedTreeIndex = treeIndex + 1;
        return _objectSpread(_objectSpread({}, parentNode), {}, {
          children: [newNode]
        });
      }

      if (typeof parentNode.children === "function") {
        throw new TypeError("Cannot add to children defined by a function");
      }

      var nextTreeIndex = treeIndex + 1;

      for (var i = 0; i < parentNode.children.length; i += 1) {
        nextTreeIndex += 1 + getDescendantCount({
          node: parentNode.children[i],
          ignoreCollapsed: ignoreCollapsed
        });
      }

      insertedTreeIndex = nextTreeIndex;
      var children = addAsFirstChild ? [newNode].concat(_toConsumableArray(parentNode.children)) : [].concat(_toConsumableArray(parentNode.children), [newNode]);
      return _objectSpread(_objectSpread({}, parentNode), {}, {
        children: children
      });
    }
  });

  if (!hasBeenAdded) {
    throw new Error("No node found with the given key.");
  }

  return {
    treeData: changedTreeData,
    treeIndex: insertedTreeIndex
  };
};

var addNodeAtDepthAndIndex = function addNodeAtDepthAndIndex(_ref23) {
  var targetDepth = _ref23.targetDepth,
      minimumTreeIndex = _ref23.minimumTreeIndex,
      newNode = _ref23.newNode,
      ignoreCollapsed = _ref23.ignoreCollapsed,
      expandParent = _ref23.expandParent,
      _ref23$isPseudoRoot = _ref23.isPseudoRoot,
      isPseudoRoot = _ref23$isPseudoRoot === void 0 ? false : _ref23$isPseudoRoot,
      isLastChild = _ref23.isLastChild,
      node = _ref23.node,
      currentIndex = _ref23.currentIndex,
      currentDepth = _ref23.currentDepth,
      getNodeKey = _ref23.getNodeKey,
      _ref23$path = _ref23.path,
      path = _ref23$path === void 0 ? [] : _ref23$path;

  var selfPath = function selfPath(n) {
    return isPseudoRoot ? [] : [].concat(_toConsumableArray(path), [getNodeKey({
      node: n,
      treeIndex: currentIndex
    })]);
  };

  if (currentIndex >= minimumTreeIndex - 1 || isLastChild && !(node.children && node.children.length > 0)) {
    if (typeof node.children === "function") {
      throw new TypeError("Cannot add to children defined by a function");
    } else {
      var extraNodeProps = expandParent ? {
        expanded: true
      } : {};

      var nextNode2 = _objectSpread(_objectSpread(_objectSpread({}, node), extraNodeProps), {}, {
        children: node.children ? [newNode].concat(_toConsumableArray(node.children)) : [newNode]
      });

      return {
        node: nextNode2,
        nextIndex: currentIndex + 2,
        insertedTreeIndex: currentIndex + 1,
        parentPath: selfPath(nextNode2),
        parentNode: isPseudoRoot ? void 0 : nextNode2
      };
    }
  }

  if (currentDepth >= targetDepth - 1) {
    if (!node.children || typeof node.children === "function" || node.expanded !== true && ignoreCollapsed && !isPseudoRoot) {
      return {
        node: node,
        nextIndex: currentIndex + 1
      };
    }

    var childIndex2 = currentIndex + 1;
    var insertedTreeIndex2;
    var insertIndex;

    for (var i = 0; i < node.children.length; i += 1) {
      if (childIndex2 >= minimumTreeIndex) {
        insertedTreeIndex2 = childIndex2;
        insertIndex = i;
        break;
      }

      childIndex2 += 1 + getDescendantCount({
        node: node.children[i],
        ignoreCollapsed: ignoreCollapsed
      });
    }

    if (insertIndex === null || insertIndex === void 0) {
      if (childIndex2 < minimumTreeIndex && !isLastChild) {
        return {
          node: node,
          nextIndex: childIndex2
        };
      }

      insertedTreeIndex2 = childIndex2;
      insertIndex = node.children.length;
    }

    var _nextNode = _objectSpread(_objectSpread({}, node), {}, {
      children: [].concat(_toConsumableArray(node.children.slice(0, insertIndex)), [newNode], _toConsumableArray(node.children.slice(insertIndex)))
    });

    return {
      node: _nextNode,
      nextIndex: childIndex2,
      insertedTreeIndex: insertedTreeIndex2,
      parentPath: selfPath(_nextNode),
      parentNode: isPseudoRoot ? void 0 : _nextNode
    };
  }

  if (!node.children || typeof node.children === "function" || node.expanded !== true && ignoreCollapsed && !isPseudoRoot) {
    return {
      node: node,
      nextIndex: currentIndex + 1
    };
  }

  var insertedTreeIndex;
  var pathFragment;
  var parentNode;
  var childIndex = currentIndex + 1;
  var newChildren = node.children;

  if (typeof newChildren !== "function") {
    newChildren = newChildren.map(function (child, i) {
      if (insertedTreeIndex !== null && insertedTreeIndex !== void 0) {
        return child;
      }

      var mapResult = addNodeAtDepthAndIndex({
        targetDepth: targetDepth,
        minimumTreeIndex: minimumTreeIndex,
        newNode: newNode,
        ignoreCollapsed: ignoreCollapsed,
        expandParent: expandParent,
        isLastChild: isLastChild && i === newChildren.length - 1,
        node: child,
        currentIndex: childIndex,
        currentDepth: currentDepth + 1,
        getNodeKey: getNodeKey,
        path: [] // Cannot determine the parent path until the children have been processed

      });

      if ("insertedTreeIndex" in mapResult) {
        insertedTreeIndex = mapResult.insertedTreeIndex;
        parentNode = mapResult.parentNode;
        pathFragment = mapResult.parentPath;
      }

      childIndex = mapResult.nextIndex;
      return mapResult.node;
    });
  }

  var nextNode = _objectSpread(_objectSpread({}, node), {}, {
    children: newChildren
  });

  var result = {
    node: nextNode,
    nextIndex: childIndex
  };

  if (insertedTreeIndex !== null && insertedTreeIndex !== void 0) {
    result.insertedTreeIndex = insertedTreeIndex;
    result.parentPath = [].concat(_toConsumableArray(selfPath(nextNode)), _toConsumableArray(pathFragment));
    result.parentNode = parentNode;
  }

  return result;
};

var insertNode = function insertNode(_ref24) {
  var treeData = _ref24.treeData,
      targetDepth = _ref24.depth,
      minimumTreeIndex = _ref24.minimumTreeIndex,
      newNode = _ref24.newNode,
      getNodeKey = _ref24.getNodeKey,
      _ref24$ignoreCollapse = _ref24.ignoreCollapsed,
      ignoreCollapsed = _ref24$ignoreCollapse === void 0 ? true : _ref24$ignoreCollapse,
      _ref24$expandParent = _ref24.expandParent,
      expandParent = _ref24$expandParent === void 0 ? false : _ref24$expandParent;

  if (!treeData && targetDepth === 0) {
    return {
      treeData: [newNode],
      treeIndex: 0,
      path: [getNodeKey({
        node: newNode,
        treeIndex: 0
      })],
      parentNode: void 0
    };
  }

  var insertResult = addNodeAtDepthAndIndex({
    targetDepth: targetDepth,
    minimumTreeIndex: minimumTreeIndex,
    newNode: newNode,
    ignoreCollapsed: ignoreCollapsed,
    expandParent: expandParent,
    getNodeKey: getNodeKey,
    isPseudoRoot: true,
    isLastChild: true,
    node: {
      children: treeData
    },
    currentIndex: -1,
    currentDepth: -1
  });

  if (!("insertedTreeIndex" in insertResult)) {
    throw new Error("No suitable position found to insert.");
  }

  var treeIndex = insertResult.insertedTreeIndex;
  return {
    treeData: insertResult.node.children,
    treeIndex: treeIndex,
    path: [].concat(_toConsumableArray(insertResult.parentPath), [getNodeKey({
      node: newNode,
      treeIndex: treeIndex
    })]),
    parentNode: insertResult.parentNode
  };
};

var getFlatDataFromTree = function getFlatDataFromTree(_ref25) {
  var treeData = _ref25.treeData,
      getNodeKey = _ref25.getNodeKey,
      _ref25$ignoreCollapse = _ref25.ignoreCollapsed,
      ignoreCollapsed = _ref25$ignoreCollapse === void 0 ? true : _ref25$ignoreCollapse;

  if (!treeData || treeData.length === 0) {
    return [];
  }

  var flattened = [];
  walk({
    treeData: treeData,
    getNodeKey: getNodeKey,
    ignoreCollapsed: ignoreCollapsed,
    callback: function callback(nodeInfo) {
      flattened.push(nodeInfo);
    }
  });
  return flattened;
};

var getTreeFromFlatData = function getTreeFromFlatData(_ref26) {
  var flatData = _ref26.flatData,
      _ref26$getKey = _ref26.getKey,
      getKey = _ref26$getKey === void 0 ? function (node) {
    return node.id;
  } : _ref26$getKey,
      _ref26$getParentKey = _ref26.getParentKey,
      getParentKey = _ref26$getParentKey === void 0 ? function (node) {
    return node.parentId;
  } : _ref26$getParentKey,
      _ref26$rootKey = _ref26.rootKey,
      rootKey = _ref26$rootKey === void 0 ? "0" : _ref26$rootKey;

  if (!flatData) {
    return [];
  }

  var childrenToParents = {};

  var _iterator = _createForOfIteratorHelper(flatData),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;
      var parentKey = getParentKey(child);

      if (parentKey in childrenToParents) {
        childrenToParents[parentKey].push(child);
      } else {
        childrenToParents[parentKey] = [child];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (!(rootKey in childrenToParents)) {
    return [];
  }

  var trav = function trav(parent) {
    var parentKey = getKey(parent);

    if (parentKey in childrenToParents) {
      return _objectSpread(_objectSpread({}, parent), {}, {
        children: childrenToParents[parentKey].map(function (child) {
          return trav(child);
        })
      });
    }

    return _objectSpread({}, parent);
  };

  return childrenToParents[rootKey].map(function (child) {
    return trav(child);
  });
};

var isDescendant = function isDescendant(older, younger) {
  return !!older.children && typeof older.children !== "function" && older.children.some(function (child) {
    return child === younger || isDescendant(child, younger);
  });
};

var getDepth = function getDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!node.children) {
    return depth;
  }

  if (typeof node.children === "function") {
    return depth + 1;
  }

  return node.children.reduce(function (deepest, child) {
    return Math.max(deepest, getDepth(child, depth + 1));
  }, depth);
};

var find = function find(_ref27) {
  var getNodeKey = _ref27.getNodeKey,
      treeData = _ref27.treeData,
      searchQuery = _ref27.searchQuery,
      searchMethod = _ref27.searchMethod,
      searchFocusOffset = _ref27.searchFocusOffset,
      _ref27$expandAllMatch = _ref27.expandAllMatchPaths,
      expandAllMatchPaths = _ref27$expandAllMatch === void 0 ? false : _ref27$expandAllMatch,
      _ref27$expandFocusMat = _ref27.expandFocusMatchPaths,
      expandFocusMatchPaths = _ref27$expandFocusMat === void 0 ? true : _ref27$expandFocusMat;
  var matchCount = 0;

  var trav = function trav(_ref28) {
    var _ref28$isPseudoRoot = _ref28.isPseudoRoot,
        isPseudoRoot = _ref28$isPseudoRoot === void 0 ? false : _ref28$isPseudoRoot,
        node = _ref28.node,
        currentIndex = _ref28.currentIndex,
        _ref28$path = _ref28.path,
        path = _ref28$path === void 0 ? [] : _ref28$path;
    var matches = [];
    var isSelfMatch = false;
    var hasFocusMatch = false;
    var selfPath = isPseudoRoot ? [] : [].concat(_toConsumableArray(path), [getNodeKey({
      node: node,
      treeIndex: currentIndex
    })]);
    var extraInfo = isPseudoRoot ? void 0 : {
      path: selfPath,
      treeIndex: currentIndex
    };
    var hasChildren = node.children && typeof node.children !== "function" && node.children.length > 0;

    if (!isPseudoRoot && searchMethod(_objectSpread(_objectSpread({}, extraInfo), {}, {
      node: node,
      searchQuery: searchQuery
    }))) {
      if (matchCount === searchFocusOffset) {
        hasFocusMatch = true;
      }

      matchCount += 1;
      isSelfMatch = true;
    }

    var childIndex = currentIndex;

    var newNode = _objectSpread({}, node);

    if (hasChildren) {
      newNode.children = newNode.children.map(function (child) {
        var mapResult = trav({
          node: child,
          currentIndex: childIndex + 1,
          path: selfPath
        });

        if (mapResult.node.expanded) {
          childIndex = mapResult.treeIndex;
        } else {
          childIndex += 1;
        }

        if (mapResult.matches.length > 0 || mapResult.hasFocusMatch) {
          matches = [].concat(_toConsumableArray(matches), _toConsumableArray(mapResult.matches));

          if (mapResult.hasFocusMatch) {
            hasFocusMatch = true;
          }

          if (expandAllMatchPaths && mapResult.matches.length > 0 || (expandAllMatchPaths || expandFocusMatchPaths) && mapResult.hasFocusMatch) {
            newNode.expanded = true;
          }
        }

        return mapResult.node;
      });
    }

    if (!isPseudoRoot && !newNode.expanded) {
      matches = matches.map(function (match) {
        return _objectSpread(_objectSpread({}, match), {}, {
          treeIndex: void 0
        });
      });
    }

    if (isSelfMatch) {
      matches = [_objectSpread(_objectSpread({}, extraInfo), {}, {
        node: newNode
      })].concat(_toConsumableArray(matches));
    }

    return {
      node: matches.length > 0 ? newNode : node,
      matches: matches,
      hasFocusMatch: hasFocusMatch,
      treeIndex: childIndex
    };
  };

  var result = trav({
    node: {
      children: treeData
    },
    isPseudoRoot: true,
    currentIndex: -1
  });
  return {
    matches: result.matches,
    treeData: result.node.children
  };
};

var classnames = function classnames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.filter(Boolean).join(" ");
};

var defaultProps$3 = {
  isSearchMatch: false,
  isSearchFocus: false,
  canDrag: false,
  toggleChildrenVisibility: void 0,
  buttons: [],
  className: "",
  style: {},
  parentNode: void 0,
  draggedNode: void 0,
  canDrop: false,
  title: void 0,
  subtitle: void 0,
  rowDirection: "ltr"
};

var NodeRendererDefault = function NodeRendererDefault(props) {
  props = _objectSpread(_objectSpread({}, defaultProps$3), props);

  var _props = props,
      scaffoldBlockPxWidth = _props.scaffoldBlockPxWidth,
      toggleChildrenVisibility = _props.toggleChildrenVisibility,
      connectDragPreview = _props.connectDragPreview,
      connectDragSource = _props.connectDragSource,
      isDragging = _props.isDragging,
      canDrop = _props.canDrop,
      canDrag = _props.canDrag,
      node = _props.node,
      title = _props.title,
      subtitle = _props.subtitle,
      draggedNode = _props.draggedNode,
      path = _props.path,
      treeIndex = _props.treeIndex,
      isSearchMatch = _props.isSearchMatch,
      isSearchFocus = _props.isSearchFocus,
      buttons = _props.buttons,
      className = _props.className,
      style = _props.style,
      didDrop = _props.didDrop,
      _treeId = _props.treeId,
      _isOver = _props.isOver,
      _parentNode = _props.parentNode,
      rowDirection = _props.rowDirection,
      otherProps = _objectWithoutProperties(_props, _excluded);

  var nodeTitle = title || node.title;
  var nodeSubtitle = subtitle || node.subtitle;
  var rowDirectionClass = rowDirection === "rtl" ? "rst__rtl" : void 0;
  var handle;

  if (canDrag) {
    handle = typeof node.children === "function" && node.expanded ? /* @__PURE__ */jsx("div", {
      className: "rst__loadingHandle",
      children: /* @__PURE__ */jsx("div", {
        className: "rst__loadingCircle",
        children: Array.from({
          length: 12
        }).map(function (_, index) {
          return /* @__PURE__ */jsx("div", {
            className: classnames("rst__loadingCirclePoint", rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : "")
          }, index);
        })
      })
    }) : connectDragSource( /* @__PURE__ */jsx("div", {
      className: "rst__moveHandle"
    }), {
      dropEffect: "copy"
    });
  }

  var isDraggedDescendant = draggedNode && isDescendant(draggedNode, node);
  var isLandingPadActive = !didDrop && isDragging;
  var buttonStyle = {
    left: -0.5 * scaffoldBlockPxWidth,
    right: 0
  };

  if (rowDirection === "rtl") {
    buttonStyle = {
      right: -0.5 * scaffoldBlockPxWidth,
      left: 0
    };
  }

  return /* @__PURE__ */jsxs("div", _objectSpread(_objectSpread({
    style: {
      height: "100%"
    }
  }, otherProps), {}, {
    children: [toggleChildrenVisibility && node.children && (node.children.length > 0 || typeof node.children === "function") && /* @__PURE__ */jsxs("div", {
      children: [/* @__PURE__ */jsx("button", {
        type: "button",
        "aria-label": node.expanded ? "Collapse" : "Expand",
        className: classnames(node.expanded ? "rst__collapseButton" : "rst__expandButton", rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : ""),
        style: buttonStyle,
        onClick: function onClick() {
          return toggleChildrenVisibility({
            node: node,
            path: path,
            treeIndex: treeIndex
          });
        }
      }), node.expanded && !isDragging && /* @__PURE__ */jsx("div", {
        style: {
          width: scaffoldBlockPxWidth
        },
        className: classnames("rst__lineChildren", rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : "")
      })]
    }), /* @__PURE__ */jsx("div", {
      className: classnames("rst__rowWrapper", rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : ""),
      children: connectDragPreview( /* @__PURE__ */jsxs("div", {
        className: classnames("rst__row", isLandingPadActive ? "rst__rowLandingPad" : "", isLandingPadActive && !canDrop ? "rst__rowCancelPad" : "", isSearchMatch ? "rst__rowSearchMatch" : "", isSearchFocus ? "rst__rowSearchFocus" : "", rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : "", className !== null && className !== void 0 ? className : ""),
        style: _objectSpread({
          opacity: isDraggedDescendant ? 0.5 : 1
        }, style),
        children: [handle, /* @__PURE__ */jsxs("div", {
          className: classnames("rst__rowContents", canDrag ? "" : "rst__rowContentsDragDisabled", rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : ""),
          children: [/* @__PURE__ */jsxs("div", {
            className: classnames("rst__rowLabel", rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : ""),
            children: [/* @__PURE__ */jsx("span", {
              className: classnames("rst__rowTitle", node.subtitle ? "rst__rowTitleWithSubtitle" : ""),
              children: typeof nodeTitle === "function" ? nodeTitle({
                node: node,
                path: path,
                treeIndex: treeIndex
              }) : nodeTitle
            }), nodeSubtitle && /* @__PURE__ */jsx("span", {
              className: "rst__rowSubtitle",
              children: typeof nodeSubtitle === "function" ? nodeSubtitle({
                node: node,
                path: path,
                treeIndex: treeIndex
              }) : nodeSubtitle
            })]
          }), /* @__PURE__ */jsx("div", {
            className: "rst__rowToolbar",
            children: buttons == null ? void 0 : buttons.map(function (btn, index) {
              return /* @__PURE__ */jsx("div", {
                className: "rst__toolbarButton",
                children: btn
              }, index);
            })
          })]
        })]
      }))
    })]
  }));
};

var defaultProps$2 = {
  isOver: false,
  canDrop: false
};

var PlaceholderRendererDefault = function PlaceholderRendererDefault(props) {
  props = _objectSpread(_objectSpread({}, defaultProps$2), props);
  var _props2 = props,
      canDrop = _props2.canDrop,
      isOver = _props2.isOver;
  return /* @__PURE__ */jsx("div", {
    className: classnames("rst__placeholder", canDrop ? "rst__placeholderLandingPad" : "", canDrop && !isOver ? "rst__placeholderCancelPad" : "")
  });
};

var defaultProps$1 = {
  swapFrom: void 0,
  swapDepth: void 0,
  swapLength: void 0,
  canDrop: false,
  draggedNode: void 0,
  rowDirection: "ltr"
};

var TreeNodeComponent = /*#__PURE__*/function (_Component) {
  _inherits(TreeNodeComponent, _Component);

  var _super = _createSuper(TreeNodeComponent);

  function TreeNodeComponent() {
    _classCallCheck(this, TreeNodeComponent);

    return _super.apply(this, arguments);
  }

  _createClass(TreeNodeComponent, [{
    key: "render",
    value: function render() {
      var _this = this;

      var props = _objectSpread(_objectSpread({}, defaultProps$1), this.props);

      var children = props.children,
          listIndex = props.listIndex,
          swapFrom = props.swapFrom,
          swapLength = props.swapLength,
          swapDepth = props.swapDepth,
          scaffoldBlockPxWidth = props.scaffoldBlockPxWidth,
          lowerSiblingCounts = props.lowerSiblingCounts,
          connectDropTarget = props.connectDropTarget,
          isOver = props.isOver,
          draggedNode = props.draggedNode,
          canDrop = props.canDrop,
          treeIndex = props.treeIndex,
          rowHeight = props.rowHeight,
          _treeId = props.treeId,
          _getPrevRow = props.getPrevRow,
          _node = props.node,
          _path = props.path,
          rowDirection = props.rowDirection,
          otherProps = _objectWithoutProperties(props, _excluded2);

      var rowDirectionClass = rowDirection === "rtl" ? "rst__rtl" : void 0;
      var scaffoldBlockCount = lowerSiblingCounts.length;
      var scaffold = [];

      var _iterator2 = _createForOfIteratorHelper(lowerSiblingCounts.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref31 = _step2.value;

          var _ref30 = _slicedToArray(_ref31, 2);

          var i = _ref30[0];
          var lowerSiblingCount = _ref30[1];
          var lineClass = "";

          if (lowerSiblingCount > 0) {
            if (listIndex === 0) {
              lineClass = "rst__lineHalfHorizontalRight rst__lineHalfVerticalBottom";
            } else if (i === scaffoldBlockCount - 1) {
              lineClass = "rst__lineHalfHorizontalRight rst__lineFullVertical";
            } else {
              lineClass = "rst__lineFullVertical";
            }
          } else if (listIndex === 0) {
            lineClass = "rst__lineHalfHorizontalRight";
          } else if (i === scaffoldBlockCount - 1) {
            lineClass = "rst__lineHalfVerticalTop rst__lineHalfHorizontalRight";
          }

          scaffold.push( /* @__PURE__ */jsx("div", {
            style: {
              width: scaffoldBlockPxWidth
            },
            className: classnames("rst__lineBlock", lineClass, rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : "")
          }, "pre_".concat(1 + i)));

          if (treeIndex !== listIndex && i === swapDepth) {
            var highlightLineClass = "";

            if (listIndex === swapFrom + swapLength - 1) {
              highlightLineClass = "rst__highlightBottomLeftCorner";
            } else if (treeIndex === swapFrom) {
              highlightLineClass = "rst__highlightTopLeftCorner";
            } else {
              highlightLineClass = "rst__highlightLineVertical";
            }

            var style2 = rowDirection === "rtl" ? {
              width: scaffoldBlockPxWidth,
              right: scaffoldBlockPxWidth * i
            } : {
              width: scaffoldBlockPxWidth,
              left: scaffoldBlockPxWidth * i
            };
            scaffold.push( /* @__PURE__ */jsx("div", {
              style: style2,
              className: classnames("rst__absoluteLineBlock", highlightLineClass, rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : "")
            }, i));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var style = rowDirection === "rtl" ? {
        right: scaffoldBlockPxWidth * scaffoldBlockCount
      } : {
        left: scaffoldBlockPxWidth * scaffoldBlockCount
      };
      var calculatedRowHeight = rowHeight;

      if (typeof rowHeight === "function") {
        calculatedRowHeight = rowHeight(treeIndex, _node, _path);
      }

      return connectDropTarget( /* @__PURE__ */jsxs("div", _objectSpread(_objectSpread({}, otherProps), {}, {
        style: {
          height: "".concat(calculatedRowHeight, "px")
        },
        className: classnames("rst__node", rowDirectionClass !== null && rowDirectionClass !== void 0 ? rowDirectionClass : ""),
        ref: function ref(node) {
          return _this.node = node;
        },
        children: [scaffold, /* @__PURE__ */jsx("div", {
          className: "rst__nodeContent",
          style: style,
          children: Children.map(children, function (child) {
            return /*#__PURE__*/cloneElement(child, {
              isOver: isOver,
              canDrop: canDrop,
              draggedNode: draggedNode
            });
          })
        })]
      })));
    }
  }]);

  return TreeNodeComponent;
}(Component);

var defaultProps = {
  canDrop: false,
  draggedNode: void 0
};

var TreePlaceholder = function TreePlaceholder(props) {
  props = _objectSpread(_objectSpread({}, defaultProps), props);

  var _props3 = props,
      children = _props3.children,
      connectDropTarget = _props3.connectDropTarget,
      treeId = _props3.treeId,
      drop = _props3.drop,
      otherProps = _objectWithoutProperties(_props3, _excluded3);

  return connectDropTarget( /* @__PURE__ */jsx("div", {
    children: Children.map(children, function (child) {
      return /*#__PURE__*/cloneElement(child, _objectSpread({}, otherProps));
    })
  }));
};

var rafId = 0;

var nodeDragSourcePropInjection = function nodeDragSourcePropInjection(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
    didDrop: monitor.didDrop()
  };
};

var wrapSource = function wrapSource(el, startDrag, _endDrag, dndType) {
  var nodeDragSource = {
    beginDrag: function beginDrag(props) {
      startDrag(props);
      return {
        node: props.node,
        parentNode: props.parentNode,
        path: props.path,
        treeIndex: props.treeIndex,
        treeId: props.treeId
      };
    },
    endDrag: function endDrag(props, monitor) {
      _endDrag(monitor.getDropResult());
    },
    isDragging: function isDragging(props, monitor) {
      var dropTargetNode = monitor.getItem().node;
      var draggedNode = props.node;
      return draggedNode === dropTargetNode;
    }
  };
  return DragSource(dndType, nodeDragSource, nodeDragSourcePropInjection)(el);
};

var propInjection = function propInjection(connect, monitor) {
  var dragged = monitor.getItem();
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    draggedNode: dragged ? dragged.node : void 0
  };
};

var wrapPlaceholder = function wrapPlaceholder(el, treeId, _drop, dndType) {
  var placeholderDropTarget = {
    drop: function drop(dropTargetProps, monitor) {
      var _monitor$getItem = monitor.getItem(),
          node = _monitor$getItem.node,
          path = _monitor$getItem.path,
          treeIndex = _monitor$getItem.treeIndex;

      var result = {
        node: node,
        path: path,
        treeIndex: treeIndex,
        treeId: treeId,
        minimumTreeIndex: 0,
        depth: 0
      };

      _drop(result);

      return result;
    }
  };
  return DropTarget(dndType, placeholderDropTarget, propInjection)(el);
};

var getTargetDepth = function getTargetDepth(dropTargetProps, monitor, component, canNodeHaveChildren, treeId, maxDepth) {
  var dropTargetDepth = 0;
  var rowAbove = dropTargetProps.getPrevRow();

  if (rowAbove) {
    var node = rowAbove.node;
    var path = rowAbove.path;
    var aboveNodeCannotHaveChildren = !canNodeHaveChildren(node);

    if (aboveNodeCannotHaveChildren) {
      path = path.slice(0, -1);
    }

    dropTargetDepth = Math.min(path.length, dropTargetProps.path.length);
  }

  var blocksOffset;
  var dragSourceInitialDepth = (monitor.getItem().path || []).length;

  if (monitor.getItem().treeId === treeId) {
    var direction = dropTargetProps.rowDirection === "rtl" ? -1 : 1;
    blocksOffset = Math.round(direction * monitor.getDifferenceFromInitialOffset().x / dropTargetProps.scaffoldBlockPxWidth);
  } else {
    dragSourceInitialDepth = 0;

    if (component) {
      var relativePosition = component.node.getBoundingClientRect();
      var leftShift = monitor.getSourceClientOffset().x - relativePosition.left;
      blocksOffset = Math.round(leftShift / dropTargetProps.scaffoldBlockPxWidth);
    } else {
      blocksOffset = dropTargetProps.path.length;
    }
  }

  var targetDepth = Math.min(dropTargetDepth, Math.max(0, dragSourceInitialDepth + blocksOffset - 1));

  if (maxDepth !== void 0 && maxDepth !== void 0) {
    var draggedNode = monitor.getItem().node;
    var draggedChildDepth = getDepth(draggedNode);
    targetDepth = Math.max(0, Math.min(targetDepth, maxDepth - draggedChildDepth - 1));
  }

  return targetDepth;
};

var _canDrop = function canDrop(dropTargetProps, monitor, canNodeHaveChildren, treeId, maxDepth, treeRefcanDrop, draggingTreeData, treeReftreeData, getNodeKey) {
  if (!monitor.isOver()) {
    return false;
  }

  var rowAbove = dropTargetProps.getPrevRow();
  var abovePath = rowAbove ? rowAbove.path : [];
  var aboveNode = rowAbove ? rowAbove.node : {};
  var targetDepth = getTargetDepth(dropTargetProps, monitor, void 0, canNodeHaveChildren, treeId, maxDepth);

  if (targetDepth >= abovePath.length && typeof aboveNode.children === "function") {
    return false;
  }

  if (typeof treeRefcanDrop === "function") {
    var _monitor$getItem2 = monitor.getItem(),
        node = _monitor$getItem2.node;

    return treeRefcanDrop({
      node: node,
      prevPath: monitor.getItem().path,
      prevParent: monitor.getItem().parentNode,
      prevTreeIndex: monitor.getItem().treeIndex,
      // Equals -1 when dragged from external tree
      nextPath: dropTargetProps.children.props.path,
      nextParent: dropTargetProps.children.props.parentNode,
      nextTreeIndex: dropTargetProps.children.props.treeIndex
    });
  }

  return true;
};

var wrapTarget = function wrapTarget(el, canNodeHaveChildren, treeId, maxDepth, treeRefcanDrop, _drop2, dragHover, dndType, draggingTreeData, treeReftreeData, getNodeKey) {
  var nodeDropTarget = {
    drop: function drop(dropTargetProps, monitor, component) {
      var result = {
        node: monitor.getItem().node,
        path: monitor.getItem().path,
        treeIndex: monitor.getItem().treeIndex,
        treeId: treeId,
        minimumTreeIndex: dropTargetProps.treeIndex,
        depth: getTargetDepth(dropTargetProps, monitor, component, canNodeHaveChildren, treeId, maxDepth)
      };

      _drop2(result);

      return result;
    },
    hover: function hover(dropTargetProps, monitor, component) {
      var targetDepth = getTargetDepth(dropTargetProps, monitor, component, canNodeHaveChildren, treeId, maxDepth);
      var draggedNode = monitor.getItem().node;
      var needsRedraw = // Redraw if hovered above different nodes
      dropTargetProps.node !== draggedNode || // Or hovered above the same node but at a different depth
      targetDepth !== dropTargetProps.path.length - 1;

      if (!needsRedraw) {
        return;
      }

      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        var item = monitor.getItem();

        if (!item || !monitor.isOver()) {
          return;
        }

        dragHover({
          node: draggedNode,
          path: item.path,
          minimumTreeIndex: dropTargetProps.listIndex,
          depth: targetDepth
        });
      });
    },
    canDrop: function canDrop(dropTargetProps, monitor) {
      return _canDrop(dropTargetProps, monitor, canNodeHaveChildren, treeId, maxDepth, treeRefcanDrop);
    }
  };
  return DropTarget(dndType, nodeDropTarget, propInjection)(el);
};

var slideRows = function slideRows(rows, fromIndex, toIndex) {
  var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var rowsWithoutMoved = [].concat(_toConsumableArray(rows.slice(0, fromIndex)), _toConsumableArray(rows.slice(fromIndex + count)));
  return [].concat(_toConsumableArray(rowsWithoutMoved.slice(0, toIndex)), _toConsumableArray(rows.slice(fromIndex, fromIndex + count)), _toConsumableArray(rowsWithoutMoved.slice(toIndex)));
};

var memoize = function memoize(f) {
  var savedArgsArray = [];
  var savedKeysArray = [];
  var savedResult;
  return function (args) {
    var keysArray = Object.keys(args).sort();
    var argsArray = keysArray.map(function (key) {
      return args[key];
    });

    if (argsArray.length !== savedArgsArray.length || argsArray.some(function (arg, index) {
      return arg !== savedArgsArray[index];
    }) || keysArray.some(function (key, index) {
      return key !== savedKeysArray[index];
    })) {
      savedArgsArray = argsArray;
      savedKeysArray = keysArray;
      savedResult = f(args);
    }

    return savedResult;
  };
};

var memoizedInsertNode = memoize(insertNode);
var memoizedGetFlatDataFromTree = memoize(getFlatDataFromTree);
var memoizedGetDescendantCount = memoize(getDescendantCount);
var treeIdCounter = 1;

var mergeTheme = function mergeTheme(props) {
  var merged = _objectSpread(_objectSpread({}, props), {}, {
    style: _objectSpread(_objectSpread({}, props.theme.style), props.style),
    innerStyle: _objectSpread(_objectSpread({}, props.theme.innerStyle), props.innerStyle)
  });

  var overridableDefaults = {
    nodeContentRenderer: NodeRendererDefault,
    placeholderRenderer: PlaceholderRendererDefault,
    scaffoldBlockPxWidth: 44,
    slideRegionSize: 100,
    rowHeight: 62,
    treeNodeRenderer: TreeNodeComponent
  };

  for (var _i2 = 0, _Object$keys = Object.keys(overridableDefaults); _i2 < _Object$keys.length; _i2++) {
    var propKey = _Object$keys[_i2];

    if (props[propKey] === void 0) {
      merged[propKey] = props.theme[propKey] === void 0 ? overridableDefaults[propKey] : props.theme[propKey];
    }
  }

  return merged;
};

var ReactSortableTree = /*#__PURE__*/function (_Component2) {
  _inherits(ReactSortableTree, _Component2);

  var _super2 = _createSuper(ReactSortableTree);

  function ReactSortableTree(props) {
    var _this2;

    _classCallCheck(this, ReactSortableTree);

    _this2 = _super2.call(this, props);

    _this2.startDrag = function (_ref32) {
      var path = _ref32.path;

      _this2.setState(function (prevState) {
        var _removeNode = removeNode({
          treeData: prevState.instanceProps.treeData,
          path: path,
          getNodeKey: _this2.props.getNodeKey
        }),
            draggingTreeData = _removeNode.treeData,
            draggedNode = _removeNode.node,
            draggedMinimumTreeIndex = _removeNode.treeIndex;

        return {
          draggingTreeData: draggingTreeData,
          draggedNode: draggedNode,
          draggedDepth: path.length - 1,
          draggedMinimumTreeIndex: draggedMinimumTreeIndex,
          dragging: true
        };
      });
    };

    _this2.dragHover = function (_ref33) {
      var draggedNode = _ref33.node,
          draggedDepth = _ref33.depth,
          draggedMinimumTreeIndex = _ref33.minimumTreeIndex;

      if (_this2.state.draggedDepth === draggedDepth && _this2.state.draggedMinimumTreeIndex === draggedMinimumTreeIndex) {
        return;
      }

      _this2.setState(function (_ref34) {
        var draggingTreeData = _ref34.draggingTreeData,
            instanceProps = _ref34.instanceProps;
        var newDraggingTreeData = draggingTreeData || instanceProps.treeData;
        var addedResult = memoizedInsertNode({
          treeData: newDraggingTreeData,
          newNode: draggedNode,
          depth: draggedDepth,
          minimumTreeIndex: draggedMinimumTreeIndex,
          expandParent: true,
          getNodeKey: _this2.props.getNodeKey
        });

        var rows = _this2.getRows(addedResult.treeData);

        var expandedParentPath = rows[addedResult.treeIndex].path;
        return {
          draggedNode: draggedNode,
          draggedDepth: draggedDepth,
          draggedMinimumTreeIndex: draggedMinimumTreeIndex,
          draggingTreeData: changeNodeAtPath({
            treeData: newDraggingTreeData,
            path: expandedParentPath.slice(0, -1),
            newNode: function newNode(_ref35) {
              var node = _ref35.node;
              return _objectSpread(_objectSpread({}, node), {}, {
                expanded: true
              });
            },
            getNodeKey: _this2.props.getNodeKey
          }),
          // reset the scroll focus so it doesn't jump back
          // to a search result while dragging
          searchFocusTreeIndex: void 0,
          dragging: true
        };
      });
    };

    _this2.endDrag = function (dropResult) {
      var instanceProps = _this2.state.instanceProps;

      if (!dropResult) {
        _this2.setState({
          draggingTreeData: void 0,
          draggedNode: void 0,
          draggedMinimumTreeIndex: void 0,
          draggedDepth: void 0,
          dragging: false
        });
      } else if (dropResult.treeId !== _this2.treeId) {
        var node = dropResult.node,
            path = dropResult.path,
            treeIndex = dropResult.treeIndex;
        var shouldCopy = _this2.props.shouldCopyOnOutsideDrop;

        if (typeof shouldCopy === "function") {
          shouldCopy = shouldCopy({
            node: node,
            prevTreeIndex: treeIndex,
            prevPath: path
          });
        }

        var treeData = _this2.state.draggingTreeData || instanceProps.treeData;

        if (shouldCopy) {
          treeData = changeNodeAtPath({
            treeData: instanceProps.treeData,
            // use treeData unaltered by the drag operation
            path: path,
            newNode: function newNode(_ref36) {
              var copyNode = _ref36.node;
              return _objectSpread({}, copyNode);
            },
            // create a shallow copy of the node
            getNodeKey: _this2.props.getNodeKey
          });
        }

        _this2.props.onChange(treeData);

        _this2.props.onMoveNode({
          treeData: treeData,
          node: node,
          treeIndex: void 0,
          path: void 0,
          nextPath: void 0,
          nextTreeIndex: void 0,
          prevPath: path,
          prevTreeIndex: treeIndex
        });
      }
    };

    _this2.drop = function (dropResult) {
      _this2.moveNode(dropResult);
    };

    _this2.canNodeHaveChildren = function (node) {
      var canNodeHaveChildren = _this2.props.canNodeHaveChildren;

      if (canNodeHaveChildren) {
        return canNodeHaveChildren(node);
      }

      return true;
    };

    _this2.listRef = props.virtuosoRef || /*#__PURE__*/React.createRef();
    _this2.listProps = props.virtuosoProps || {};

    var _mergeTheme = mergeTheme(props),
        dndType = _mergeTheme.dndType,
        nodeContentRenderer = _mergeTheme.nodeContentRenderer,
        treeNodeRenderer = _mergeTheme.treeNodeRenderer,
        slideRegionSize = _mergeTheme.slideRegionSize;

    _this2.treeId = "rst__".concat(treeIdCounter);
    treeIdCounter += 1;
    _this2.dndType = dndType || _this2.treeId;
    _this2.nodeContentRenderer = wrapSource(nodeContentRenderer, _this2.startDrag, _this2.endDrag, _this2.dndType);
    _this2.treePlaceholderRenderer = wrapPlaceholder(TreePlaceholder, _this2.treeId, _this2.drop, _this2.dndType);
    _this2.scrollZoneVirtualList = (createScrollingComponent || withScrolling)( /*#__PURE__*/React.forwardRef(function (props2, ref) {
      var dragDropManager = props2.dragDropManager,
          rowHeight = props2.rowHeight,
          otherProps = _objectWithoutProperties(props2, _excluded4);

      return /* @__PURE__ */jsx(Virtuoso, _objectSpread({
        ref: _this2.listRef,
        scrollerRef: function scrollerRef(scrollContainer) {
          return ref.current = scrollContainer;
        }
      }, otherProps));
    }));
    _this2.vStrength = createVerticalStrength(slideRegionSize);
    _this2.hStrength = createHorizontalStrength(slideRegionSize);
    _this2.state = {
      draggingTreeData: void 0,
      draggedNode: void 0,
      draggedMinimumTreeIndex: void 0,
      draggedDepth: void 0,
      searchMatches: [],
      searchFocusTreeIndex: void 0,
      dragging: false,
      // props that need to be used in gDSFP or static functions will be stored here
      instanceProps: {
        treeData: [],
        ignoreOneTreeUpdate: false,
        searchQuery: void 0,
        searchFocusOffset: void 0
      }
    };
    _this2.treeNodeRenderer = wrapTarget(treeNodeRenderer, _this2.canNodeHaveChildren, _this2.treeId, _this2.props.maxDepth, _this2.props.canDrop, _this2.drop, _this2.dragHover, _this2.dndType, _this2.state.draggingTreeData, _this2.props.treeData, _this2.props.getNodeKey);
    _this2.toggleChildrenVisibility = _this2.toggleChildrenVisibility.bind(_assertThisInitialized(_this2));
    _this2.moveNode = _this2.moveNode.bind(_assertThisInitialized(_this2));
    _this2.startDrag = _this2.startDrag.bind(_assertThisInitialized(_this2));
    _this2.dragHover = _this2.dragHover.bind(_assertThisInitialized(_this2));
    _this2.endDrag = _this2.endDrag.bind(_assertThisInitialized(_this2));
    _this2.drop = _this2.drop.bind(_assertThisInitialized(_this2));
    _this2.handleDndMonitorChange = _this2.handleDndMonitorChange.bind(_assertThisInitialized(_this2));
    return _this2;
  } // returns the new state after search


  _createClass(ReactSortableTree, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      ReactSortableTree.loadLazyChildren(this.props, this.state);
      var stateUpdate = ReactSortableTree.search(this.props, this.state, true, true, false);
      this.setState(stateUpdate);
      this.clearMonitorSubscription = this.props.dragDropManager.getMonitor().subscribeToStateChange(this.handleDndMonitorChange);
    }
  }, {
    key: "componentDidUpdate",
    value: // listen to dragging
    function componentDidUpdate(prevProps, prevState) {
      if (this.state.dragging !== prevState.dragging && this.props.onDragStateChanged) {
        this.props.onDragStateChanged({
          isDragging: this.state.dragging,
          draggedNode: this.state.draggedNode
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearMonitorSubscription();
    }
  }, {
    key: "handleDndMonitorChange",
    value: function handleDndMonitorChange() {
      var _this3 = this;

      var monitor = this.props.dragDropManager.getMonitor();

      if (!monitor.isDragging() && this.state.draggingTreeData) {
        setTimeout(function () {
          _this3.endDrag();
        });
      }
    }
  }, {
    key: "getRows",
    value: function getRows(treeData) {
      return memoizedGetFlatDataFromTree({
        ignoreCollapsed: true,
        getNodeKey: this.props.getNodeKey,
        treeData: treeData
      });
    }
  }, {
    key: "toggleChildrenVisibility",
    value: function toggleChildrenVisibility(_ref37) {
      var targetNode = _ref37.node,
          path = _ref37.path;
      var instanceProps = this.state.instanceProps;
      var treeData = changeNodeAtPath({
        treeData: instanceProps.treeData,
        path: path,
        newNode: function newNode(_ref38) {
          var node = _ref38.node;
          return _objectSpread(_objectSpread({}, node), {}, {
            expanded: !node.expanded
          });
        },
        getNodeKey: this.props.getNodeKey
      });
      this.props.onChange(treeData);
      this.props.onVisibilityToggle({
        treeData: treeData,
        node: targetNode,
        expanded: !targetNode.expanded,
        path: path
      });
    }
  }, {
    key: "moveNode",
    value: function moveNode(_ref39) {
      var node = _ref39.node,
          prevPath = _ref39.path,
          prevTreeIndex = _ref39.treeIndex,
          depth = _ref39.depth,
          minimumTreeIndex = _ref39.minimumTreeIndex;

      var _insertNode = insertNode({
        treeData: this.state.draggingTreeData,
        newNode: node,
        depth: depth,
        minimumTreeIndex: minimumTreeIndex,
        expandParent: true,
        getNodeKey: this.props.getNodeKey
      }),
          treeData = _insertNode.treeData,
          treeIndex = _insertNode.treeIndex,
          path = _insertNode.path,
          nextParentNode = _insertNode.parentNode;

      this.props.onChange(treeData);
      this.props.onMoveNode({
        treeData: treeData,
        node: node,
        treeIndex: treeIndex,
        path: path,
        nextPath: path,
        nextTreeIndex: treeIndex,
        prevPath: prevPath,
        prevTreeIndex: prevTreeIndex,
        nextParentNode: nextParentNode
      });
    }
  }, {
    key: "renderRow",
    value: function renderRow(row, _ref40) {
      var listIndex = _ref40.listIndex,
          style = _ref40.style,
          getPrevRow = _ref40.getPrevRow,
          matchKeys = _ref40.matchKeys,
          swapFrom = _ref40.swapFrom,
          swapDepth = _ref40.swapDepth,
          swapLength = _ref40.swapLength;
      var node = row.node,
          parentNode = row.parentNode,
          path = row.path,
          lowerSiblingCounts = row.lowerSiblingCounts,
          treeIndex = row.treeIndex;

      var _mergeTheme2 = mergeTheme(this.props),
          canDrag = _mergeTheme2.canDrag,
          generateNodeProps = _mergeTheme2.generateNodeProps,
          scaffoldBlockPxWidth = _mergeTheme2.scaffoldBlockPxWidth,
          searchFocusOffset = _mergeTheme2.searchFocusOffset,
          rowDirection = _mergeTheme2.rowDirection,
          rowHeight = _mergeTheme2.rowHeight;

      var TreeNodeRenderer = this.treeNodeRenderer;
      var NodeContentRenderer = this.nodeContentRenderer;
      var nodeKey = path[path.length - 1];
      var isSearchMatch = (nodeKey in matchKeys);
      var isSearchFocus = isSearchMatch && matchKeys[nodeKey] === searchFocusOffset;
      var callbackParams = {
        node: node,
        parentNode: parentNode,
        path: path,
        lowerSiblingCounts: lowerSiblingCounts,
        treeIndex: treeIndex,
        isSearchMatch: isSearchMatch,
        isSearchFocus: isSearchFocus
      };
      var nodeProps = generateNodeProps ? generateNodeProps(callbackParams) : {};
      var rowCanDrag = typeof canDrag === "function" ? canDrag(callbackParams) : canDrag;
      var sharedProps = {
        treeIndex: treeIndex,
        scaffoldBlockPxWidth: scaffoldBlockPxWidth,
        node: node,
        path: path,
        treeId: this.treeId,
        rowDirection: rowDirection
      };
      return /* @__PURE__ */jsx(TreeNodeRenderer, _objectSpread(_objectSpread({
        style: style,
        rowHeight: rowHeight,
        listIndex: listIndex,
        getPrevRow: getPrevRow,
        lowerSiblingCounts: lowerSiblingCounts,
        swapFrom: swapFrom,
        swapLength: swapLength,
        swapDepth: swapDepth
      }, sharedProps), {}, {
        children: /* @__PURE__ */jsx(NodeContentRenderer, _objectSpread(_objectSpread({
          parentNode: parentNode,
          isSearchMatch: isSearchMatch,
          isSearchFocus: isSearchFocus,
          canDrag: rowCanDrag,
          toggleChildrenVisibility: this.toggleChildrenVisibility
        }, sharedProps), nodeProps))
      }), nodeKey);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _mergeTheme3 = mergeTheme(this.props),
          dragDropManager = _mergeTheme3.dragDropManager,
          style = _mergeTheme3.style,
          className = _mergeTheme3.className,
          innerStyle = _mergeTheme3.innerStyle,
          placeholderRenderer = _mergeTheme3.placeholderRenderer,
          getNodeKey = _mergeTheme3.getNodeKey,
          rowDirection = _mergeTheme3.rowDirection;

      var _this$state = this.state,
          searchMatches = _this$state.searchMatches,
          searchFocusTreeIndex = _this$state.searchFocusTreeIndex,
          draggedNode = _this$state.draggedNode,
          draggedDepth = _this$state.draggedDepth,
          draggedMinimumTreeIndex = _this$state.draggedMinimumTreeIndex,
          instanceProps = _this$state.instanceProps;
      var treeData = this.state.draggingTreeData || instanceProps.treeData;
      var rowDirectionClass = rowDirection === "rtl" ? "rst__rtl" : void 0;
      var rows;
      var swapFrom;
      var swapLength;

      if (draggedNode && draggedMinimumTreeIndex !== void 0) {
        var addedResult = memoizedInsertNode({
          treeData: treeData,
          newNode: draggedNode,
          depth: draggedDepth,
          minimumTreeIndex: draggedMinimumTreeIndex,
          expandParent: true,
          getNodeKey: getNodeKey
        });
        var swapTo = draggedMinimumTreeIndex;
        swapFrom = addedResult.treeIndex;
        swapLength = 1 + memoizedGetDescendantCount({
          node: draggedNode
        });
        rows = slideRows(this.getRows(addedResult.treeData), swapFrom, swapTo, swapLength);
      } else {
        rows = this.getRows(treeData);
      }

      var matchKeys = {};

      var _iterator3 = _createForOfIteratorHelper(searchMatches.entries()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref43 = _step3.value;

          var _ref42 = _slicedToArray(_ref43, 2);

          var i = _ref42[0];
          var path = _ref42[1].path;
          matchKeys[path[path.length - 1]] = i;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (searchFocusTreeIndex !== void 0) {
        this.listRef.current.scrollToIndex({
          index: searchFocusTreeIndex,
          align: "center"
        });
      }

      var containerStyle = style;
      var list;

      if (rows.length === 0) {
        var Placeholder = this.treePlaceholderRenderer;
        var PlaceholderContent = placeholderRenderer;
        list = /* @__PURE__ */jsx(Placeholder, {
          treeId: this.treeId,
          drop: this.drop,
          children: /* @__PURE__ */jsx(PlaceholderContent, {})
        });
      } else {
        containerStyle = _objectSpread({
          height: "100%"
        }, containerStyle);
        var ScrollZoneVirtualList = this.scrollZoneVirtualList;
        list = /* @__PURE__ */jsx(ScrollZoneVirtualList, _objectSpread({
          data: rows,
          dragDropManager: dragDropManager,
          verticalStrength: this.vStrength,
          horizontalStrength: this.hStrength,
          className: "rst__virtualScrollOverride",
          style: innerStyle,
          itemContent: function itemContent(index) {
            return _this4.renderRow(rows[index], {
              listIndex: index,
              getPrevRow: function getPrevRow() {
                return rows[index - 1] || void 0;
              },
              matchKeys: matchKeys,
              swapFrom: swapFrom,
              swapDepth: draggedDepth,
              swapLength: swapLength
            });
          }
        }, this.listProps));
      }

      return /* @__PURE__ */jsx("div", {
        className: classnames("rst__tree", className, rowDirectionClass),
        style: containerStyle,
        children: list
      });
    }
  }], [{
    key: "search",
    value: function search(props, state, seekIndex, expand, singleSearch) {
      var onChange = props.onChange,
          getNodeKey = props.getNodeKey,
          searchFinishCallback = props.searchFinishCallback,
          searchQuery = props.searchQuery,
          searchMethod = props.searchMethod,
          searchFocusOffset = props.searchFocusOffset,
          onlyExpandSearchedNodes = props.onlyExpandSearchedNodes;
      var instanceProps = state.instanceProps;

      if (!searchQuery && !searchMethod) {
        if (searchFinishCallback) {
          searchFinishCallback([]);
        }

        return {
          searchMatches: []
        };
      }

      var newState = {
        instanceProps: {}
      };

      var _find = find({
        getNodeKey: getNodeKey,
        treeData: onlyExpandSearchedNodes ? toggleExpandedForAll({
          treeData: instanceProps.treeData,
          expanded: false
        }) : instanceProps.treeData,
        searchQuery: searchQuery,
        searchMethod: searchMethod || defaultSearchMethod,
        searchFocusOffset: searchFocusOffset,
        expandAllMatchPaths: expand && !singleSearch,
        expandFocusMatchPaths: !!expand
      }),
          expandedTreeData = _find.treeData,
          searchMatches = _find.matches;

      if (expand) {
        newState.instanceProps.ignoreOneTreeUpdate = true;
        onChange(expandedTreeData);
      }

      if (searchFinishCallback) {
        searchFinishCallback(searchMatches);
      }

      var searchFocusTreeIndex;

      if (seekIndex && searchFocusOffset !== void 0 && searchFocusOffset < searchMatches.length) {
        searchFocusTreeIndex = searchMatches[searchFocusOffset].treeIndex;
      }

      newState.searchMatches = searchMatches;
      newState.searchFocusTreeIndex = searchFocusTreeIndex;
      return newState;
    } // Load any children in the tree that are given by a function
    // calls the onChange callback on the new treeData

  }, {
    key: "loadLazyChildren",
    value: function loadLazyChildren(props, state) {
      var instanceProps = state.instanceProps;
      walk({
        treeData: instanceProps.treeData,
        getNodeKey: props.getNodeKey,
        callback: function callback(_ref44) {
          var node = _ref44.node,
              path = _ref44.path,
              lowerSiblingCounts = _ref44.lowerSiblingCounts,
              treeIndex = _ref44.treeIndex;

          if (node.children && typeof node.children === "function" && (node.expanded || props.loadCollapsedLazyChildren)) {
            node.children({
              node: node,
              path: path,
              lowerSiblingCounts: lowerSiblingCounts,
              treeIndex: treeIndex,
              // Provide a helper to append the new data when it is received
              done: function done(childrenArray) {
                return props.onChange(changeNodeAtPath({
                  treeData: instanceProps.treeData,
                  path: path,
                  newNode: function newNode(_ref45) {
                    var oldNode = _ref45.node;
                    return (// Only replace the old node if it's the one we set off to find children
                      //  for in the first place
                      oldNode === node ? _objectSpread(_objectSpread({}, oldNode), {}, {
                        children: childrenArray
                      }) : oldNode
                    );
                  },
                  getNodeKey: props.getNodeKey
                }));
              }
            });
          }
        }
      });
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var instanceProps = prevState.instanceProps;
      var newState = {};

      var newInstanceProps = _objectSpread({}, instanceProps);

      var isTreeDataEqual = isEqual(instanceProps.treeData, nextProps.treeData);
      newInstanceProps.treeData = nextProps.treeData;

      if (!isTreeDataEqual) {
        if (instanceProps.ignoreOneTreeUpdate) {
          newInstanceProps.ignoreOneTreeUpdate = false;
        } else {
          newState.searchFocusTreeIndex = void 0;
          ReactSortableTree.loadLazyChildren(nextProps, prevState);
          Object.assign(newState, ReactSortableTree.search(nextProps, prevState, false, false, false));
        }

        newState.draggingTreeData = void 0;
        newState.draggedNode = void 0;
        newState.draggedMinimumTreeIndex = void 0;
        newState.draggedDepth = void 0;
        newState.dragging = false;
      } else if (!isEqual(instanceProps.searchQuery, nextProps.searchQuery)) {
        Object.assign(newState, ReactSortableTree.search(nextProps, prevState, true, true, false));
      } else if (instanceProps.searchFocusOffset !== nextProps.searchFocusOffset) {
        Object.assign(newState, ReactSortableTree.search(nextProps, prevState, true, true, true));
      }

      newInstanceProps.searchQuery = nextProps.searchQuery;
      newInstanceProps.searchFocusOffset = nextProps.searchFocusOffset;
      newState.instanceProps = _objectSpread(_objectSpread({}, newInstanceProps), newState.instanceProps);
      return newState;
    }
  }]);

  return ReactSortableTree;
}(Component);

ReactSortableTree.defaultProps = {
  canDrag: true,
  canDrop: void 0,
  canNodeHaveChildren: function canNodeHaveChildren() {
    return true;
  },
  className: "",
  dndType: void 0,
  generateNodeProps: void 0,
  getNodeKey: defaultGetNodeKey,
  innerStyle: {},
  maxDepth: void 0,
  treeNodeRenderer: void 0,
  nodeContentRenderer: void 0,
  onMoveNode: function onMoveNode() {},
  onVisibilityToggle: function onVisibilityToggle() {},
  placeholderRenderer: void 0,
  scaffoldBlockPxWidth: void 0,
  searchFinishCallback: void 0,
  searchFocusOffset: void 0,
  searchMethod: void 0,
  searchQuery: void 0,
  shouldCopyOnOutsideDrop: false,
  slideRegionSize: void 0,
  style: {},
  theme: {},
  onDragStateChanged: function onDragStateChanged() {},
  onlyExpandSearchedNodes: false,
  rowDirection: "ltr",
  debugMode: false,
  overscan: 0
};

var SortableTreeWithoutDndContext = function SortableTreeWithoutDndContext(props) {
  return /* @__PURE__ */jsx(DndContext.Consumer, {
    children: function children(_ref46) {
      var dragDropManager = _ref46.dragDropManager;
      return dragDropManager === void 0 ? void 0 : /* @__PURE__ */jsx(ReactSortableTree, _objectSpread(_objectSpread({}, props), {}, {
        dragDropManager: dragDropManager
      }));
    }
  });
};

var SortableTree = function SortableTree(props) {
  return /* @__PURE__ */jsx(DndProvider, {
    debugMode: props.debugMode,
    backend: HTML5Backend,
    children: /* @__PURE__ */jsx(SortableTreeWithoutDndContext, _objectSpread({}, props))
  });
};

export { SortableTreeWithoutDndContext, addNodeUnderParent, changeNodeAtPath, SortableTree as default, defaultGetNodeKey, defaultSearchMethod, find, getDepth, getDescendantCount, getFlatDataFromTree, getNodeAtPath, getTreeFromFlatData, getVisibleNodeCount, getVisibleNodeInfoAtIndex, insertNode, isDescendant, map, removeNode, removeNodeAtPath, toggleExpandedForAll, walk };